import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { Checkbox, CustomIcon } from '../../common';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginLeft: -8
  },
  checkbox: {
    padding: 8
  },
  icon: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: 8,
    boxSizing: 'border-box'
  },
  labelBold: {
    ...theme.typography.body2Bold
  },
  label: {
    ...theme.typography.body2
  },
  labelSmall: {
    ...theme.typography.subtitle2,
    paddingLeft: 8
  }
}));

const PaymentFormCheckbox = ({
  id,
  className,
  name,
  validator,
  label,
  color = 'primary',
  variant = 'selectedBold',
  value,
  onClick
}) => {
  const classes = useStyles();

  const labelClass =
    variant === 'alwaysBold' || (variant === 'selectedBold' && !!value)
      ? classes.labelBold
      : variant === 'small'
      ? classes.labelSmall
      : classes.label;
  return (
    <Checkbox
      translated
      id={id}
      name={name}
      validate={validator}
      label={label}
      value={value}
      onClick={onClick}
      classNameWrapper={classNames(classes.wrapper, className)}
      className={classes.checkbox}
      classNameLabel={labelClass}
      icon={<span className={classes.icon} />}
      checkedIcon={
        <span className={classes.icon}>
          <CustomIcon icon="confirm" size="xs" variant={color} />
        </span>
      }
    />
  );
};

export default PaymentFormCheckbox;
